import { Model } from "./Model";
import { Player } from "./Index";

export interface Substitute extends Model {
	fixtureId: number;
	playerOffId: number;
	playerOnId: number;
	playerOff: Player
	playerOn: Player
}

export class Substitute implements Substitute {

	constructor(data?: Partial<Substitute>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}